export const SITE = {
  name: "Jay Jagannath Tour & Travels",
  domain: "https://jayjagannathtravels.in",
  phoneDisplay: "+91 70082 11164",
  phoneHref: "tel:+917008211164",
  location: "Rayagada, Odisha, India",
  email: "contact@jayjagannathtravels.in",
  address: "New Colony, 1st Lane, near V-Bazar, Rayagada, Odisha 765001",
  hours: "Opens 7:00 AM, every day",
};

export const waLink = (text) =>
  `https://wa.me/917008211164?text=${encodeURIComponent(text)}`;

export const WA_DEFAULT = waLink(
  "Hello Jay Jagannath Tour & Travels, I would like to book a trip. Please share details."
);

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1706790574525-d218c4c52b5c?crop=entropy&cs=srgb&fm=jpg&q=85",
  deities: "https://images.unsplash.com/photo-1722404348790-85bf847dd863?crop=entropy&cs=srgb&fm=jpg&q=85",
  temple: "https://images.unsplash.com/photo-1661771402987-9dc9db2cbb63?crop=entropy&cs=srgb&fm=jpg&q=85",
  mercedes: "https://images.unsplash.com/photo-1686834950048-d5117c4fa6d9?crop=entropy&cs=srgb&fm=jpg&q=85",
  suv: "https://images.unsplash.com/photo-1781197824875-c6e07188896b?crop=entropy&cs=srgb&fm=jpg&q=85",
  sedan: "https://images.unsplash.com/photo-1633510657984-5f1ed399a1f1?crop=entropy&cs=srgb&fm=jpg&q=85",
  chilika: "https://images.unsplash.com/photo-1697118813798-50571001c53f?crop=entropy&cs=srgb&fm=jpg&q=85",
  boats: "https://images.unsplash.com/photo-1575336127377-71c4af9ce931?crop=entropy&cs=srgb&fm=jpg&q=85",
};
